import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D4E38BC9-5A85-4890-B3DD-92F3D263E26E
 * name chart-bell-curve-cumulative
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-bell-curve-cumulative.svg
 * tags
 * - Math 
 */
export const ChartBellCurveCumulativeIcon = createSvgIcon(<><path d="M4 19V20H22V22H2V2H4V17C7 17 10 15 12.1 11.4C15.1 6.4 18.4 4 22 4V6C19.2 6 16.5 8.1 13.9 12.5C11.3 16.6 7.7 19 4 19Z" /></>, 'ChartBellCurveCumulativeIcon');
export default ChartBellCurveCumulativeIcon